import styled from "styled-components";

export const FlorenzSelect = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  min-width: 148px;
  .input-container {
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    border: none;
    padding: ${({ xsSize }) => (xsSize ? "5px 10px" : "10px")};
    border-radius: 14px;
    display: flex;
    align-items: center;
    min-width: 100px;
    background-color: ${({ theme, forWhiteBackgroud, disabled }) =>
      disabled ? "#CFD3DD" : forWhiteBackgroud ? "#F0F0FF" : "#FFFFFF"};
    .label {
      display: flex;
      align-items: center;
      margin-bottom: ${({ xsSize }) => (xsSize ? "-4px" : "-6px")};
      &__text {
        color: #1f1f52;
        font-size: ${({ xsSize }) => (xsSize ? "14px" : "17px")};
      }
      &__icon {
        margin-left: 10px;
        &-required {
          font-size: 17px;
        }
        &-icon {
          font-size: 7px;
        }
      }
      &--no-margin {
        margin-bottom: 0px;
      }
    }
    .icon-input-form {
      justify-content: center;
      display: flex;
      font-size: ${({ xsSize }) => (xsSize ? "13px" : "25px")};
      margin-right: 10px;
      height: ${({ xsSize }) => (xsSize ? "18px" : "34px")};
      width: ${({ xsSize }) => (xsSize ? "18px" : "34px")};
      box-sizing: border-box;
      &__icon {
        font-size: ${({ xsSize }) => (xsSize ? "9px" : "25px")};
        align-items: center;
        color: #3e3e5b;
        display: flex;
      }
    }
    .text-info {
      width: 100%;
    }
    input {
      border: none;
      background-color: transparent;
      width: 100%;
      font-family: ${({ xsSize }) =>
        xsSize ? "Nunito Sans" : "Nunito Sans Bold"};
      cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
      font-size: ${({ xsSize }) => (xsSize ? "14px" : "14px")};
      text-overflow: ellipsis;
      /* color: ${({ value }) => (value ? "#0C0AA2" : "#3E3E5B")}; */
      color: #0c0aa2;
      &:focus {
        outline: none;
      }
      &::placeholder {
        font-size: 14px;
        margin-left: 30px;
        font-family: ${({ xsSize }) =>
          xsSize ? "Nunito Sans" : "Nunito Sans Bold"};
        color: #3e3e5b;
      }
    }
    .input-icon-arrow {
      min-width: 26px;
      height: 23px;
      border-radius: 34px;
      background-color: ${({ disabled, forWhiteBackgroud }) =>
        forWhiteBackgroud ? "#FFFFFF" : "#EFEFF9"};
      display: flex;
      margin-left: auto;
    }
    .icon-input-form-arrow {
      font-size: 6px;
      transition: 0.3s ease;
      transform: ${({ listActive }) =>
        listActive ? "rotate(180deg)" : "none"};
      margin: auto;
    }
  }
  .select-list {
    position: absolute;
    background-color: ${({ theme }) => theme.inputBackground};
    z-index: 200;
    display: ${({ listActive }) => (listActive ? "block" : "none")};
    width: 100%;
    max-height: ${({ heightList }) => heightList};
    /* max-height: 100px; */
    overflow-y: auto;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0px 3px 6px ${({ theme }) => theme.blackShadow}29;
    font-family: "Nunito Sans";
    font-size: 14px;
    .select-item {
      cursor: pointer;
      padding: 3px 7px;
      label {
        cursor: pointer;
      }
    }
  }
  .input-error {
    height: 15px;
    padding: 1px 5px;
    font-size: 10px;
    color: ${({ theme }) => theme.warning};
    display: flex;
    align-items: center;
    i {
      margin-right: 2px;
    }
  }
`;
